import React from 'react';
import { Edit } from 'react-admin';
import { t } from 'i18next';

import { CustomEditToolbar } from '../CustomEditToolbar';
import { SizeClassMixForm } from './SizeClassMixForm';

export const SizeClassMixEdit = props => (
  <Edit {...props} title={t('size_class_mix.title')}>
    <SizeClassMixForm toolbar={<CustomEditToolbar user={props.options.currentUser.role}/>}/>
  </Edit>
);